module.exports = __webpack_public_path__ + "abf5aa80eec3384158baa47d76ef0f9e.mp3";